<template>
  <base-layout>
    <template>
      <details-page-title
        :title="
          $t(
            'components.marketPlaceManagement.buyers.details.buyerManagement.headline'
          )
        "
        :details-id="id"
      />

      <details-page-header
        :name="getName"
        :badge="getBadge"
        :avatar="getAvatar"
        :email="getEmail"
        :tabs="tabs"
      />

      <div class="min-h-screen">
        <router-view />
      </div>
    </template>
  </base-layout>
</template>

<script>
import BaseLayout from '@/views/shared/BaseLayout'
import DetailsPageTitle from '@/components/ui/DetailsPageTitle.vue'
import DetailsPageHeader from '@/components/ui/DetailsPageHeader.vue'
export default {
  name: 'ViewBuyerDetails',
  components: {
    BaseLayout,
    DetailsPageTitle,
    DetailsPageHeader,
  },
  async created() {
    await this.$store.dispatch('buyerDetails/fetchData', this.id)
    this.header = this.$store.getters['buyerDetails/getData']

    // fail safe
    if (!this.header) {
      await this.$store.dispatch('buyerDetails/fetchData', this.id)
      this.header = this.$store.getters['buyerDetails/getData']
    }
  },

  data() {
    return {
      header: {},
      symbol: '$',

      fallbackText: '--',

      tabs: [
        {
          text: this.$t(
            'components.marketPlaceManagement.buyers.details.buyerManagement.tabs.profile'
          ),
          href: this.getTabHref(`profile`),
        },
        {
          text: this.$t(
            'components.marketPlaceManagement.buyers.details.buyerManagement.tabs.orders'
          ),
          href: this.getTabHref(`orders`),
        },
        {
          text: this.$t(
            'components.marketPlaceManagement.buyers.details.buyerManagement.tabs.vehicles'
          ),
          href: this.getTabHref(`vehicles`),
        },
      ],
    }
  },

  computed: {
    id() {
      return this.$route.params.id
    },
    getName() {
      return this.header.user
        ? `${this.header.user.first_name} ${this.header.user.last_name}`
        : ''
    },
    getBadge() {
      return 'Buyer'
    },

    getAvatar() {
      return ''
    },
    getEmail() {
      return this.header.user ? this.header.user.email : ''
    },
  },

  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
    },
    getTabHref(path) {
      return `/marketplaces/buyers/${this.$route.params.id}/${path}`
    },
  },
}
</script>
